var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8855 4.66686L4.57616 6.35753L3.6335 7.30019L0.333496 4.00019L3.6335 0.700195L4.57616 1.64286L2.8855 3.33353H7.66683C9.08132 3.33353 10.4379 3.89543 11.4381 4.89563C12.4383 5.89582 13.0002 7.25237 13.0002 8.66686C13.0002 10.0813 12.4383 11.4379 11.4381 12.4381C10.4379 13.4383 9.08132 14.0002 7.66683 14.0002H1.66683V12.6669H7.66683C8.7277 12.6669 9.74511 12.2454 10.4953 11.4953C11.2454 10.7451 11.6668 9.72773 11.6668 8.66686C11.6668 7.606 11.2454 6.58858 10.4953 5.83843C9.74511 5.08829 8.7277 4.66686 7.66683 4.66686H2.8855Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoBlue);
export default __webpack_public_path__ + "static/media/undo-blue.8f83eba0f46c3da884d66899f1ce3cfe.svg";
export { ForwardRef as ReactComponent };